import { useCallback } from "react"
import { observer } from "mobx-react-lite"
import { Button , ButtonProps } from "@fluentui/react-button"
import { AddRegular } from '@fluentui/react-icons'
import { GenericCudList } from "@knowmax/genericlist-core"

type IProps<T = unknown, ET = unknown> = {
  list: GenericCudList<T, ET>
  template?: ET
} & ButtonProps

/** Renders button to start process to create new item. */
export const CreateItem = observer(<T = unknown, ET = unknown>(props: IProps<T, ET>) => {
  const { list, template, ...buttonProps } = props

  const create = useCallback(() => {
    list.create(template)
  }, [list, template])

  return (
    <Button {...buttonProps} icon={buttonProps.icon || <AddRegular />} onClick={create} />
  )
})